import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import './Layout.scss';
import Header from '../Header';
import Footer from '../Footer';
import Form from '../Form';

const Layout = () => {
  const [isFormOpen, setFormOpen] = useState('');
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className='page'>
      <Header onFormClick={val => setFormOpen(val)} />
      <Outlet context={{ setFormOpen }} />
      <Footer onFormClick={val => setFormOpen(val)} />

      {!!isFormOpen && <Form onClose={() => setFormOpen('')} type={isFormOpen} />}
    </div>
  );
};

export default Layout;
